"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemesCSS = void 0;
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
var getThemeData_1 = require("./getThemeData");
var generateThemesCSS = function (themes, mixin, withKebabCase) {
    if (mixin === void 0) { mixin = {}; }
    var files = [];
    var groupedThemes = Object.entries(themes).reduce(function (acc, _a) {
        var _b, _c;
        var theme = _a[0], themeItem = _a[1];
        var _d = theme.split('__'), themeName = _d[0], themeType = _d[1];
        return __assign(__assign({}, acc), (_b = {}, _b[themeName] = __assign(__assign({}, acc[themeName]), (_c = {}, _c[themeType] = themeItem, _c)), _b));
    }, {});
    for (var _i = 0, _a = Object.entries(groupedThemes); _i < _a.length; _i++) {
        var _b = _a[_i], themeName = _b[0], _c = _b[1], dark = _c.dark, light = _c.light;
        var darkTheme = (0, getThemeData_1.getThemeData)(dark, mixin, withKebabCase);
        var lightTheme = (0, getThemeData_1.getThemeData)(light, mixin, withKebabCase);
        files.push((0, generateFile_1.generateCSSThemeModuleFile)("".concat(themeName, ".module"), (0, utils_1.attachToThemesMode)(darkTheme, lightTheme)));
        files.push((0, generateFile_1.generateCSSThemeRootFile)("".concat(themeName, "__dark"), (0, utils_1.attachToRoot)(darkTheme)));
        files.push((0, generateFile_1.generateCSSThemeRootFile)("".concat(themeName, "__light"), (0, utils_1.attachToRoot)(lightTheme)));
    }
    return files;
};
exports.generateThemesCSS = generateThemesCSS;
//# sourceMappingURL=generateThemesCSS.js.map